import { FC } from 'react';
import { Error } from '@mui/icons-material';
import { FormControl, FormHelperText, InputLabel } from '@mui/material';
import cn from 'classnames';

import RichEditor from '@components/RichEditor/RichEditor';

import { IFormRichEditorProps } from './FormRichEditor.interface';

import './styles.scss';

const FormRichEditor: FC<IFormRichEditorProps> = ({
  className,
  variant = 'filled',
  label,
  required,
  input: { onFocus, onBlur, onChange, value },
  meta,
}) => (
  <FormControl className={cn('form-rich-editor', className)} variant={variant}>
    <InputLabel
      className="form-rich-editor__label"
      error={meta.error && meta.touched}
      required={required}
      focused={meta.active}
      filled={!!value}
    >
      {label}
    </InputLabel>

    <div
      className={cn('form-rich-editor__input', {
        'form-rich-editor__input_active': meta.active,
        'form-rich-editor__input_error': meta.error && meta.touched,
      })}
    >
      <RichEditor
        active={!!meta.active}
        value={value}
        onFocus={onFocus}
        onBlur={onBlur}
        onChange={onChange}
      />

      {meta.error && meta.touched && (
        <Error className="form-rich-editor__error-icon" color="error" />
      )}
    </div>

    {meta.error && meta.touched && <FormHelperText error>{meta.error}</FormHelperText>}
  </FormControl>
);

export default FormRichEditor;
